import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReceiveInfoBrokerService {
  /**
   * @description constructor
   * @params http
   */
  constructor( private http: HttpClient) {
    this.http = http;
  }
  /**
   * @description Recuperar información de - Correduria - URL logo e id desde OWCS
   * @params idProveedor
   */
  getInfoBroker(idProveedor: any): Observable<any> {
    // const httpOpt: any = {
    //   headers: new HttpHeaders()
    //     .append('Content-Type', 'application/json')
    // };
    return this.http.get(
      environment.urlBaseOWCS + // Comentar si va con proxy
      environment.endpoints.broker.name + '?idProveedor=' + idProveedor
    );
  }
}
